import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../theme'

const MaxLength = styled.small<IMaxLengthProps>`
  margin-top: ${({ size }) => (size ? 5 * size : 5)}px;
  margin-right: ${({ size }) => (size ? 5 * size : 5)}px;
  font-size: ${({ size }) => (size ? 0.7 * size : 0.7)}em;

  ${is('max')`
    color: ${({ theme }: ITheme) => theme.colors.palette.reddish};
  `}
`

export default MaxLength

export interface IMaxLengthProps {
  max?: boolean
  size?: number
}
